import React from 'react';
import logo from './assets/logo.png';
import { Home, Us, Services, Contact, Footer } from './views/index.js';

import './css/normalize.css';
import './css/App.css';

const App = () => {
  const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <header className="navbar">
        <img src={logo} className="navbar__image" alt="EliumNova Logotipo" />
        <nav className="navigation">
          <ul className="container__option">
            <li>
              <a onClick={() => scrollToSection('home')} className="option">
                Inicio
              </a>
            </li>
            <li>
              <a onClick={() => scrollToSection('us')} className="option">
                Nosotros
              </a>
            </li>
            <li>
              <a onClick={() => scrollToSection('services')} className="option">
                Servicios
              </a>
            </li>
            <li>
              <a onClick={() => scrollToSection('contact')} className="option">
                Contacto
              </a>
            </li>
          </ul>
        </nav>
      </header>
      <main>
        <section id="home">
          <Home />
        </section>
        <section id="us">
          <Us />
        </section>
        <section id="services">
          <Services />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default App;
